<script lang="ts" setup>
import type { ToasterProps } from 'vue-sonner'

import { reactiveOmit } from '@vueuse/core'
import { Toaster as Sonner } from 'vue-sonner'
import { cn } from '@/lib/utils'

const props = defineProps<ToasterProps>()
const delegatedProps = reactiveOmit(props, 'class', 'toastOptions')
</script>

<template>
  <Sonner
    :class="cn('toaster group', props.class)"
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
      '--border-radius': 'var(--radius)',
      '--gray2': 'color-mix(in oklch, var(--popover) 90%, transparent)',
      '--gray3': 'var(--border)',
      '--gray4': 'var(--border)',
      '--gray5': 'var(--border)',
      '--gray12': 'var(--popover-foreground)',
    }"
    :toast-options="props.toastOptions ?? {
      classes: {
        toast: 'rounded-2xl',
      },
    }"
    v-bind="delegatedProps"
  >
    <template #success-icon>
      <Icon
        name="tabler:circle-check-filled"
        class="size-4"
      />
    </template>
    <template #info-icon>
      <Icon
        name="tabler:info-circle-filled"
        class="size-4"
      />
    </template>
    <template #warning-icon>
      <Icon
        name="tabler:alert-triangle-filled"
        class="size-4"
      />
    </template>
    <template #error-icon>
      <Icon
        name="tabler:circle-x-filled"
        class="size-4"
      />
    </template>
    <template #loading-icon>
      <div>
        <Icon
          name="tabler:loader-2"
          class="size-4 animate-spin"
        />
      </div>
    </template>
    <template #close-icon>
      <Icon
        name="tabler:x-filled"
        class="size-4"
      />
    </template>
  </Sonner>
</template>
